export default __webpack_public_path__ + "static/media/img-legal-1-l.b91af7ca.png";